import {
  OS_NAME_EVENT_FIELD,
  PRODUCT_VERTICAL_EVENT_FIELD,
  type OsName,
  type ElementName,
  type ProductVertical,
  type TrackingEventMessage,
  type EventType,
} from './constants';

import type { EventTypes } from '@web-platform/global-components-utils/tracking';

const FULL_SCHEMA_NAME = 'footer.FooterTrackingEvent';

const EVENT_NAME = 'FooterTrackingEvent';

export const getEvent = ({
  country,
  currency,
  elementName,
  eventType,
  locale,
  osName,
  pageType,
  vertical,
}: {
  elementName: ElementName;
  pageType: string;
  osName: string;
  vertical: ProductVertical;
  country: string;
  locale: string;
  currency: string;
  eventType: EventType;
}) =>
  getTrackingEvent({
    element_name: elementName,
    event_type: eventType,
    page_type: pageType,
    os_name: OS_NAME_EVENT_FIELD[osName as OsName] || OS_NAME_EVENT_FIELD.Others,
    vertical: PRODUCT_VERTICAL_EVENT_FIELD[vertical],
    culture: {
      country,
      locale,
      currency,
    },
  });

export const getTrackingEvent = (message: TrackingEventMessage): EventTypes => ({
  topic: 'grappler-track',
  data: {
    eventName: EVENT_NAME,
    fullSchemaName: FULL_SCHEMA_NAME,
    message,
    isMiniEvent: true,
    consentRequired: true,
  },
});
